var site = {

  win: null,
  doc: null,
  body: null,

  bp: {
    mobileLarge: 500,
    tablet: 620,
    tabletLarge: 788,
    desktop: 980,
    desktopLarge: 1100,
    large: 1290
  },

  flags: {

    hasTouch: function () {

      return "ontouchstart" in document || window.DocumentTouch && document instanceof DocumentTouch;

    },

    hasHistory: function () {

      return window.history && window.history.pushState;

    }

  },

  preInit: function () {
    // init
    site.init();
  },

  init: function () {
    site.smoothScroll();
    site.cms();
    site.nav();
    site.analytics.init();
  },

  nav: function () {

    $('.l-nav:not(.js-nav-done)').each(function () {
      var wrapper = $(this);
      var allow = true;
      var title = wrapper.find('.js-title');
      var menu = wrapper.find('.js-menu');
      var subTitles = wrapper.find('.js-sub-title');
      var subMenus = wrapper.find('.js-sub-menu');
      var linksWithChildren = wrapper.find('.js-nav-link-has-children');

      // click
      title.off('click').on('click', function () {
        if (!allow) return false;
        allow = false;
        title.toggleClass('active');
        $('body').toggleClass('mobile-nav-open');
        menu.slideToggle(250, function () {
          allow = true;
        });
        return false;
      });

      // sub
      subTitles.off('click').on('click', function () {
        var title = $(this);
        var menu = title.next('.js-sub-menu:first');
        if (!allow) return false;
        allow = false;
        title.toggleClass('active');
        menu.slideToggle(250, function () {
          allow = true;
        });
        return false;
      });

        linksWithChildren.off('focus').on('focus', function () {
            linksWithChildren.closest('.with-sub').removeClass('show-subnav');
            $(this).closest('.with-sub').addClass('show-subnav');
        });

        linksWithChildren.each((function () {
            $(this).closest('.with-sub').find('a').last().on('blur', function () {
                linksWithChildren.closest('.with-sub').removeClass('show-subnav');
            });
        }));

        linksWithChildren.each((function () {
            $(this).closest('.with-sub').find('a').first().on('keydown blur', function (e) {
                if (e.shiftKey && e.key === "Tab") {
                    linksWithChildren.closest('.with-sub').removeClass('show-subnav');
                } 
            });
        }));

        $(document).keyup(function (e) {
            if (e.key === "Escape") {
                linksWithChildren.closest('.with-sub').removeClass('show-subnav');
            }
        });

      // resize
      $(window).on('resize', function () {
        if (window.matchMedia('(min-width:' + site.bp.desktop + 'px)').matches) {
          subTitles.removeClass('active');
          subMenus.removeAttr('style');
        }
      });

      // done
      wrapper.addClass('js-nav-done');
    });

  },

  cms: function () {
    $('.cms:not(.js-cms-done)').each(function () {
      var wrapper = $(this);

      // tables
      wrapper.find('table:not(.js-cms-table-done)').wrap('<div class="cms-table" />')

      // done
      wrapper.addClass('js-cms-done');
    });
  },

  smoothScroll: function () {
    $('a[href*="#"]:not(.js-scroll-done)').each(function () {
      var link = $(this);
      link.on('click', function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
          var target = $(this.hash);
          target = target.length && target || $('[name=' + this.hash.slice(1) + ']');
          if (target.length) {
            var targetOffset = target.offset().top;
            if ($(window).scrollTop != targetOffset) {
              site.scrollTo(targetOffset);
            }
            return false;
          }
        }
      });
      // done
      link.addClass('js-scroll-done');
    });
  },

  scrollTo: function (offset, speed) {
    var value = parseInt(offset, 10);
    if (value < 0 && $('html, body').scrollTop !== value) return;
    $('html, body').animate({ scrollTop: value }, speed || 500);
  },

  analytics: {

    init: function () {
      $('a[data-analytics-event]:not(.js-analytics-done)').each(function () {
        var link = $(this);
        var e = link.attr('data-analytics-event').split('|');

        // click
        link.on('click', function () {
          site.analytics.track(e[0], e[1], e[2]);
        });

        // done
        link.addClass('js-analytics-done');
      });
    },

    page: function (url, title) {
      dataLayer.push({
        'virtualPageUrl': url,
        'virtualPageTitle': title,
        'event': 'VirtualPageView'
      });
    },

    track: function (category, action, label) {
      dataLayer.push({
        'eventCategory': category,
        'eventAction': action,
        'eventLabel': label,
        'event': 'EventTracking'
      });
    }
  }
};

$(function () {
  site.preInit();
  popups.preInit();
  $(document).ajaxComplete(function () {
    site.init();
  });
});